import MarketingHeader from "@/components/marketing/Header"
import MarketingFooter from "@/components/marketing/Footer"
import { PageSEO } from "@/components/page-seo"

export default function MarketingLayout({
  seoKey,
  title,
  description,
  image,
  jsonLd,
  children,
  className = "",
}) {
  return (
    <div className={`min-h-screen bg-background ${className}`}>
      <PageSEO seoKey={seoKey} title={title} description={description} image={image} jsonLd={jsonLd} />
      <MarketingHeader />
      <main>{children}</main>
      <MarketingFooter />
    </div>
  )
}
